<template lang="pug">
div.payment-settings(:class="{ 'payment-settings-dark': isDark }")
  div.payment-hero
    div.payment-hero-copy
      v-avatar.payment-hero-icon(size="48")
        v-icon(size="26") mdi-cash-sync
      div
        h2.fonte Formas de pagamento
        span.fonteMini Configure dinheiro, maquinetas, fiado e taxas de recebimento.
    v-btn.payment-hero-action(class="fonte white--text elevation-0" rounded :color="$theme.third" @click="openPaymentWizard")
      v-icon(left size="18") mdi-plus
      | Nova forma

  div.payment-grid
    div.payment-card.payment-card-money
      div.payment-card-top
        v-avatar.payment-card-icon(size="42")
          v-icon(size="24") mdi-cash
        v-chip.payment-chip(x-small color="green" dark) Padrao
      div.payment-card-body
        strong.fonte Dinheiro
        span.fonteMini Recebimento sem taxa, sempre disponivel.
      div.payment-card-footer
        span.fonteMini Taxa
        strong.fonte 0%

    div.payment-card.payment-card-add(v-if="customMethods.length === 0" @click="openPaymentWizard")
      v-avatar.payment-card-icon(size="46")
        v-icon(size="25") mdi-wallet-plus
      strong.fonte Cadastre sua primeira forma
      span.fonteMini Adicione maquineta, fiado, Pix com taxa ou outro recebimento.

    div.payment-card(v-for="(method, index) in customMethods" :key="method.id || index" :class="{ 'payment-card-off': method.active === false }")
      div.payment-card-top
        v-avatar.payment-card-icon(size="42")
          v-icon(size="23") {{ methodIcon(method.type) }}
        v-switch.payment-switch(dense hide-details inset :color="$theme.third" v-model="method.active" @change="save")
      div.payment-card-body
        strong.fonte {{ method.name }}
        span.fonteMini {{ methodTypeLabel(method.type) }}
      div.payment-card-metrics
        div
          span.fonteMini Taxa
          strong.fonte {{ method.tax_porcentage || 0 }}%
        div
          span.fonteMini Status
          strong.fonte {{ method.active === false ? "Inativa" : "Ativa" }}
      div.payment-card-actions
        v-btn(text small class="fonte" @click="removePaymentMethod(index)")
          v-icon(left size="16" color="red lighten-1") mdi-delete-outline
          | Remover

  div.finishing-panel
    div.finishing-copy
      v-avatar.payment-card-icon(size="38")
        v-icon(size="22") mdi-account-hard-hat
      div
        strong.fonte Acabamento
        span.fonteMini Percentual aplicado sobre a venda.
    v-text-field.finishing-input(filled dense hide-details suffix="%" type="Number" placeholder="ex: 2.89" v-model="payment_sys_config['finishing'].tax_porcentage" @change="save")

  v-dialog(v-model="paymentWizard" max-width="560")
    v-card.payment-wizard-card(:class="{ 'payment-wizard-dark': isDark }")
      div.payment-wizard-progress
        span(:class="{ active: paymentWizardStep >= 1 }")
        span(:class="{ active: paymentWizardStep >= 2 }")
        span(:class="{ active: paymentWizardStep >= 3 }")
      v-card-title.payment-wizard-title
        v-avatar.mr-3(size="42" :color="$theme.primary")
          v-icon(color="#111b21") mdi-wallet-plus
        div
          div.fonte Nova forma de pagamento
          small.fonteMini.grey--text Passo {{ paymentWizardStep }} de 3
      v-card-text
        v-window(v-model="paymentWizardStep")
          v-window-item(:value="1")
            div.payment-wizard-step
              h3.fonte Qual tipo de recebimento?
              span.fonteMini.grey--text Escolha como essa forma deve aparecer no caixa.
              div.payment-type-grid
                button.payment-type-card(v-for="item in methodTypes" :key="item.value" :class="{ active: paymentDraft.type === item.value }" @click="paymentDraft.type = item.value")
                  v-icon(size="24") {{ methodIcon(item.value) }}
                  strong.fonte {{ item.text }}
          v-window-item(:value="2")
            div.payment-wizard-step
              h3.fonte Dados da forma
              span.fonteMini.grey--text Informe o nome e a taxa deduzida no relatorio final.
              v-text-field(filled dense label="Nome" placeholder="Ex: Maquineta Stone" v-model="paymentDraft.name")
              v-text-field(filled dense suffix="%" label="Taxa" type="number" placeholder="Ex: 2.89" v-model="paymentDraft.tax_porcentage")
          v-window-item(:value="3")
            div.payment-wizard-success
              v-avatar(size="68" color="green")
                v-icon(color="white" size="38") mdi-check
              h3.fonte Forma cadastrada
              span.fonteMini.grey--text {{ paymentDraft.name }} ja esta disponivel para recebimentos.
      v-card-actions.px-6.pb-5
        v-btn(text class="fonte" @click="closePaymentWizard") Fechar
        v-spacer
        v-btn(v-if="paymentWizardStep > 1 && paymentWizardStep < 3" text class="fonte" @click="paymentWizardStep--") Voltar
        v-btn(v-if="paymentWizardStep < 2" class="fonte white--text elevation-0" rounded :color="$theme.third" @click="paymentWizardStep++") Continuar
        v-btn(v-if="paymentWizardStep === 2" class="fonte white--text elevation-0" rounded :color="$theme.third" :disabled="!paymentDraft.name" @click="finishPaymentWizard") Cadastrar
</template>

<script>
import { EventBus } from "@/main";

export default {
  props: ["payment_sys_config"],
  data() {
    return {
      tax_tab: 0,
      paymentWizard: false,
      paymentWizardStep: 1,
      paymentDraft: {
        name: "",
        type: "card_machine",
        tax_porcentage: 0
      },
      methodTypes: [
        { text: "Maquineta", value: "card_machine" },
        { text: "Fiado", value: "credit" },
        { text: "Outro", value: "custom" }
      ]
    };
  },
  computed: {
    isDark() {
      return localStorage.dark === "true";
    },
    customMethods() {
      return Array.isArray(this.payment_sys_config.custom_methods)
        ? this.payment_sys_config.custom_methods
        : [];
    }
  },
  methods: {
    changeConfigView(view) {
      EventBus.$emit("set-config-view", view);
    },
    openPaymentWizard() {
      this.paymentDraft = {
        name: "",
        type: "card_machine",
        tax_porcentage: 0
      };
      this.paymentWizardStep = 1;
      this.paymentWizard = true;
    },
    closePaymentWizard() {
      this.paymentWizard = false;
    },
    finishPaymentWizard() {
      if (!Array.isArray(this.payment_sys_config.custom_methods)) {
        this.$set(this.payment_sys_config, "custom_methods", []);
      }
      this.payment_sys_config.custom_methods.push({
        id: `custom_${Date.now()}`,
        name: this.paymentDraft.name,
        type: this.paymentDraft.type,
        active: true,
        tax_porcentage: Number(this.paymentDraft.tax_porcentage || 0)
      });
      this.savePaymentSysConfig();
      this.paymentWizardStep = 3;
    },
    removePaymentMethod(index) {
      this.payment_sys_config.custom_methods.splice(index, 1);
      this.save();
    },
    methodIcon(type) {
      if (type === "card_machine") return "mdi-credit-card-wireless-outline";
      if (type === "credit") return "mdi-account-clock-outline";
      return "mdi-wallet-outline";
    },
    methodTypeLabel(type) {
      const item = this.methodTypes.find(method => method.value === type);
      return item ? item.text : "Outro";
    },
    save() {
      const pendingMethod = (this.payment_sys_config.custom_methods || []).find(
        method => !method.name
      );
      if (pendingMethod) return;
      this.savePaymentSysConfig();
    },
    savePaymentSysConfig() {
      EventBus.$emit("savePaymentSysConfig", this.payment_sys_config);
    }
  }
};
</script>

<style scoped>
.payment-settings {
  color: #1f2a2e;
  padding: 4px 0 24px;
}
.payment-hero {
  align-items: center;
  background: linear-gradient(135deg, rgba(18, 140, 126, 0.12), rgba(37, 211, 102, 0.08));
  border: 1px solid rgba(18, 140, 126, 0.16);
  border-radius: 22px;
  display: flex;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
  padding: 20px;
}
.payment-hero-copy {
  align-items: center;
  display: flex;
  gap: 14px;
}
.payment-hero-copy h2 {
  margin: 0;
}
.payment-hero-copy span,
.payment-card span,
.finishing-panel span {
  color: #607178;
}
.payment-hero-icon,
.payment-card-icon {
  background: #25D366;
  color: #0b141a;
}
.payment-hero-icon .v-icon,
.payment-card-icon .v-icon {
  color: #0b141a !important;
}
.payment-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(235px, 1fr));
}
.payment-card {
  background: #ffffff;
  border: 1px solid rgba(18, 140, 126, 0.12);
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
  min-height: 176px;
  padding: 16px;
  transition: 0.18s ease;
}
.payment-card:hover {
  border-color: rgba(18, 140, 126, 0.34);
  transform: translateY(-2px);
}
.payment-card-top,
.payment-card-footer,
.payment-card-actions,
.finishing-panel,
.finishing-copy {
  align-items: center;
  display: flex;
}
.payment-card-top,
.payment-card-footer,
.payment-card-actions,
.finishing-panel {
  justify-content: space-between;
}
.payment-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
}
.payment-card-body strong {
  font-size: 16px;
}
.payment-card-footer {
  border-top: 1px solid rgba(18, 140, 126, 0.1);
  margin-top: 18px;
  padding-top: 12px;
}
.payment-card-metrics {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  margin-top: 18px;
}
.payment-card-metrics div {
  background: rgba(18, 140, 126, 0.08);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.payment-card-actions {
  margin-top: 10px;
}
.payment-card-add {
  align-items: center;
  border-style: dashed;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  text-align: center;
}
.payment-card-off {
  opacity: 0.58;
}
.payment-switch {
  margin-top: 0;
}
.finishing-panel {
  background: #ffffff;
  border: 1px solid rgba(18, 140, 126, 0.12);
  border-radius: 20px;
  gap: 16px;
  margin-top: 14px;
  padding: 16px;
}
.finishing-copy {
  gap: 12px;
}
.finishing-copy div {
  display: flex;
  flex-direction: column;
}
.finishing-input {
  max-width: 170px;
}
.payment-wizard-card {
  border-radius: 22px !important;
  overflow: hidden;
}
.payment-wizard-progress {
  display: grid;
  gap: 6px;
  grid-template-columns: repeat(3, 1fr);
  padding: 14px 18px 0;
}
.payment-wizard-progress span {
  background: #d8e6e1;
  border-radius: 999px;
  height: 5px;
}
.payment-wizard-progress span.active {
  background: #25D366;
}
.payment-wizard-title {
  background: #f7fbf9;
  border-bottom: 1px solid rgba(18, 140, 126, 0.12);
}
.payment-wizard-step {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 14px;
}
.payment-type-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);
}
.payment-type-card {
  align-items: center;
  background: #f7fbf9;
  border: 1px solid rgba(18, 140, 126, 0.14);
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 105px;
  padding: 14px 10px;
}
.payment-type-card.active {
  background: rgba(37, 211, 102, 0.16);
  border-color: #25D366;
}
.payment-wizard-success {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 210px;
  justify-content: center;
  text-align: center;
}
.payment-settings-dark {
  color: #e9edef;
}
.payment-settings-dark .payment-hero,
.payment-settings-dark .payment-card,
.payment-settings-dark .finishing-panel,
.payment-wizard-dark {
  background: #111b21 !important;
  border-color: #26343c;
  color: #e9edef !important;
  box-shadow: none;
}
.payment-settings-dark .payment-hero {
  background: linear-gradient(135deg, #111b21, #182229) !important;
}
.payment-settings-dark .payment-card-metrics div,
.payment-settings-dark .payment-type-card {
  background: #182229;
  border-color: #26343c;
}
.payment-settings-dark .payment-type-card.active {
  background: #005c4b;
  border-color: #128C7E;
}
.payment-settings-dark span,
.payment-settings-dark .grey--text,
.payment-wizard-dark .grey--text {
  color: #aebac1 !important;
}
.payment-settings-dark ::v-deep .v-input__slot,
.payment-wizard-dark ::v-deep .v-input__slot,
.payment-settings-dark ::v-deep input,
.payment-wizard-dark ::v-deep input {
  background: #202c33 !important;
  color: #e9edef !important;
}
.payment-settings-dark ::v-deep .v-label,
.payment-wizard-dark ::v-deep .v-label {
  color: #aebac1 !important;
}
.payment-wizard-dark .payment-wizard-title {
  background: #182229;
  border-bottom-color: #26343c;
}
@media(max-width: 760px) {
  .payment-hero,
  .finishing-panel {
    align-items: stretch;
    flex-direction: column;
  }
  .payment-hero-action,
  .finishing-input {
    max-width: none;
    width: 100%;
  }
  .payment-type-grid {
    grid-template-columns: 1fr;
  }
}
</style>
